import Layout from '@/layout/layout'

const classificationRouter = {
    path: '/RecyclerAccountManagenment',
    component: Layout,
    redirect: 'noRedirect',
    name: '回收商运营账户',
    children: [
        {
            path: 'rcyAccountStatement',
            component: () => import('@/views/RecyclerAccountManagenment/recycleAccountStatement/index'),
            name: '回收商保证金代管账户',
            meta: { title: '回收商保证金代管账户', noCache: true }
        }, {
            path: 'platRevenueStatement',
            component: () => import('@/views/RecyclerAccountManagenment/platRevenueStatement/index'),
            name: '商家生态服务收入账户',
            meta: { title: '商家生态服务收入账户', noCache: true }
        },{
            path: 'recyAccountStatistics',
            component: () => import('@/views/RecyclerAccountManagenment/recyAccountStatistics/index'),
            name: '回收商账户统计',
            meta: { title: '回收商账户统计', noCache: true }
        },
    ]
}

export default classificationRouter